import { render, staticRenderFns } from "./SideBarTotalCost.vue?vue&type=template&id=a9d6eefa"
import script from "./SideBarTotalCost.vue?vue&type=script&lang=js"
export * from "./SideBarTotalCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports